<template>
    <div class="panel__list__item">
        <span>{{item.start_date | formatDate}} - {{item.end_date ? ($options.filters.formatDate(item.end_date)) : $t('dashboard.studies.ongoing')}}</span>
        <h3 class="purple">{{item.study_level.name}}, {{item.study.id === 182 ? item.study_name : item.study.name}}</h3>
        <h3>{{item.institute_name}}</h3>
        <span>{{$t('dashboard.studies.diploma_achieved')}} : {{item.finished ? $t('common.yes') : $t('common.no')}}</span>

        <div class="panel__list__item__actions">
            <span class="panel__list__item__action" @click="editStudy">
                <i class="icons icon-pencil"></i>
                <a class="button--link">{{$t('common.edit')}}</a>
            </span>
            <span class="panel__list__item__action" @click="showDeleteStudyModal">
                <i class="icons icon-trash"></i>
                <a class="button--link">{{$t('common.delete')}}</a>
            </span>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';

    import { GET_STUDIES } from '@/store/modules/studies';

    @Component
    export default class StudiesItem extends Vue {
        name = 'study-item';

        @Prop()
        item;

        editStudy() {
            this.$modal.show('study-modal', { study: this.item });
        }

        showDeleteStudyModal() {
            const content = {
                title: this.$t('modals.delete_study.title'),
                message: this.$t('modals.delete_study.message'),
            };
            this.$modal.show('confirmation-modal', { content, callback: this.deleteStudy, study: this.item});
        }

        deleteStudy({study}) {
            study.remove()
                .then(() => {
                    this.$notify.success(this.$t('notify.study.delete_success'));
                    this.$store.dispatch(GET_STUDIES, {});
                })
                .catch(err => this.$notify.error(this.$t('notify.study.delete_error')));
        }

    }

</script>



// WEBPACK FOOTER //
// src/components/panels/dashboard/StudiesItem.vue